import React, { useEffect, useRef, useState } from 'react';
import logoPng from 'src/_shared/assets/images/logo.png';
import './style/loader.component.style.scss';

interface Props {
    isLoading: boolean;
}

const DISMISS_DELAY_MS = 350;

const Loader: React.FC<Props> = ({ isLoading }) => {
    const [visible, setVisible] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (isLoading) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            setVisible(true);
        } else if (visible) {
            timerRef.current = setTimeout(() => {
                setVisible(false);
                timerRef.current = null;
            }, DISMISS_DELAY_MS);
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [isLoading]);

    return visible ? (
        <div className='loader-overlay'>
            <div className='loader-content'>
                <img className='loader-logo' src={logoPng} alt='Loading' />
                <span className='loader-text'>Caricamento...</span>
            </div>
        </div>
    ) : null;
};

export default Loader;
